// Normalizes REACT_APP_SUBDOMAIN_ROOT regardless of how it's set in .env —
// if it looks like a full URL (https://myvajra.ai/, or with a path/port),
// parse it with URL and take just the hostname; otherwise it's already a
// bare domain. Prevents a misconfigured env var from breaking the
// host.endsWith() check below (a value like "https://myvajra.ai/" would
// never match a real hostname, which never contains "https://").
const getSubdomainRoot = () => {
  const raw = process.env.REACT_APP_SUBDOMAIN_ROOT || "myvajra.ai";
  if (/^https?:\/\//i.test(raw)) {
    try {
      return new URL(raw).hostname;
    } catch (e) {
      // Malformed URL — fall through and strip what we can by hand.
    }
  }
  return raw.replace(/^https?:\/\//i, "").replace(/\/+$/, "");
};
const SUBDOMAIN_ROOT = getSubdomainRoot();

// Extracts the consultant's subdomain label from the current URL — e.g.
// "my-domain" from my-domain.vajra.in. Returns null on the plain root
// domain, localhost, or any host that isn't actually a *.vajra.in
// subdomain, so this is always a no-op unless a consultant has genuinely
// registered one (see the White Labeling page / utils/consultantDomain.js
// on the backend).
//
// Dev-only override: on localhost, a ?testSubdomain=my-domain query param
// simulates any subdomain without needing a hosts file entry per label —
// only ever active on localhost, so it can't be triggered on the real
// vajra.in domain.
export const getSubdomainLabel = () => {
  const host = window.location.hostname;

  if (host === "localhost" || host === "127.0.0.1") {
    return new URLSearchParams(window.location.search).get("testSubdomain") || null;
  }

  if (!host.endsWith(`.${SUBDOMAIN_ROOT}`)) return null;
  const label = host.slice(0, -1 * (SUBDOMAIN_ROOT.length + 1));
  return label || null;
};

// The main (non-subdomain) site — where a visitor is sent when they land on
// a subdomain that no consultant has registered. Derived from the same
// env-driven root as everything else (REACT_APP_SUBDOMAIN_ROOT), or set
// REACT_APP_MAIN_SITE_URL explicitly to override. Nothing here is hardcoded
// per environment.
export const getMainSiteUrl = () => {
  const explicit = process.env.REACT_APP_MAIN_SITE_URL;
  if (explicit) return explicit.replace(/\/+$/, "");
  return `https://${SUBDOMAIN_ROOT}`;
};